export default __webpack_public_path__ + "static/media/B52_1.eabb76bd.webp";